let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bHtk9")).then(() => parcelRequire('eZ9Cp'));